<footer class="site-footer">
  <div class="footer-inner">
    <div class="footer-brand">
      <a routerLink="/" class="footer-logo" aria-label="TheNearByShop home">
        <span class="logo-mark">TheNearByShop</span><span class="logo-tld">.com</span>
      </a>
      <p>
        Discover nearby grocery stores, pharmacies, bakeries, dairy and more. Buy online, visit in person,
        or subscribe for daily, weekly or monthly deliveries.
      </p>
      <p class="support">
        <i class="fas fa-headset" aria-hidden="true"></i>
        Customer care: <a href="tel:+918948313390">+91 89483 13390</a>
        <span class="hours">11 AM – 4 PM, Mon – Sun</span>
      </p>
    </div>

    <nav class="footer-links" aria-label="Footer">
      <div>
        <h2>Shop</h2>
        <ul>
          <li><a routerLink="/categories">All categories</a></li>
          <li><a routerLink="/stores-view-all">Shops near you</a></li>
          <li><a routerLink="/search">Search</a></li>
        </ul>
      </div>
      <div>
        <h2>Account</h2>
        <ul>
          <li><a routerLink="/profile" [queryParams]="{ tab: 'orders' }">Orders &amp; tracking</a></li>
          <li><a routerLink="/subscribe">Subscriptions</a></li>
          <li><a routerLink="/cart">Cart</a></li>
        </ul>
      </div>
      <div>
        <h2>Company</h2>
        <ul>
          <li><a routerLink="/about-us">About us</a></li>
          <li><a routerLink="/contact-us">Contact us</a></li>
          <li><a routerLink="/policy">Policies</a></li>
        </ul>
      </div>
      <div>
        <h2>Tools</h2>
        <ul>
          <li><a routerLink="/tools/train-ticket-prediction"><i class="fas fa-train" aria-hidden="true"></i> Train ticket confirmation chances</a></li>
        </ul>
      </div>
      <div>
        <h2>Partner with us</h2>
        <ul>
          <li><a routerLink="/vendor-onboarding">Sell on TheNearByShop</a></li>
          <li><a routerLink="/delivery-partner">Become a delivery partner</a></li>
        </ul>
      </div>
    </nav>
  </div>

  <div class="footer-bottom">
    <p>© {{ year }} VAMS Mechatronica Private Limited. All rights reserved.</p>
    <p class="secure"><i class="fas fa-lock" aria-hidden="true"></i> Payments processed securely by Razorpay</p>
  </div>
</footer>
